export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : '';
        this.name = item != null ? item.name : '';
        this.build = item != null ? item.build : '';
        this.notes = item != null ? item.notes : '';
        this.availableFrom = item != null ? item.availableFrom : '';
        this.active = item != null ? item.active : false;
        this.forceUpdate = item != null ? item.forceUpdate : false;
        this.availableForEveryOne = item != null ? item.availableForEveryOne : false;
        this.assignedCompanyIds = item != null ? item.assignedCompanies != undefined ? item.assignedCompanies.map(x=> x.id) : [] : []
        this.assignedUserIds =item != null ? item.assignedUsers != undefined ? item.assignedUsers.map(x=> x.id) : [] : []
    }
}